const initialState = {
    data:[],
    country:[],
    state:[],
    name:[],
    image:[],
    speciality:[],
    lan:[],
  };
  
  const PatientProfileReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, data:action.payload}
            case 'FETCH_COUNTRY_SUCCESS':
            return {... state, country:action.payload};
            case 'FETCH_STATE_SUCCESS':
            return {... state, state:action.payload};
            case 'FETCH_NAME_SUCCESS':
            return {... state, name:action.payload};
            case 'FETCH_IMG_SUCCESS':
            return {... state, image:action.payload};
            case 'FETCH_SPEC_SUCCESS':
            return {... state, speciality:action.payload};
            case 'FETCH_LAN_SUCCESS':
            return {... state, lan:action.payload};
            
          


      default:
        return state;
    }
  };
  
  export default PatientProfileReducers;
  
  